export default __webpack_public_path__ + "static/media/kitchen3-afterD-1440w.128532c9.avif";